<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="ImageComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :keyChange="keyChange"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="50"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <sync-drag :target="this" />

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-ImageComponent'>
        <img src="static/images/icons/link.svg"
             v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action"
             @click="linkElement"/>
      </options-element-bar>

      <img ref="image" :src="this.internal_config.src"
           :keyChange="keyChange"
           :config-properties="JSON.stringify(internal_config)" alt="" class="sitebuilder-element"
           v-bind:style="{opacity: opacity,'border-radius': radius, border : internal_config.border, 'box-shadow': boxShadow,}" loading="lazy">
    </vue-draggable-resizable>
  </div>
</template>

<script>

  import ImageData from './Model';
  import OptionsElementBar from '../OptionsElementBar';
  import MixinComponents from "../../../../js/mixins/MixinComponents";

  export default {
    name: 'ImageComponent',
    props: ['config', 'src', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar
    },
    computed: {
      opacity() {
        return this.internal_config.opacity;
      },
    },
    data() {
      return ImageData.data();
    },
    methods: {

      linkElement: function () {
        this.$root.$emit('linkComponentShow', this);
      },

      animation() {
        return true;
      },

      onResize: function (x, y, width, height) {
        let vm = this;
        vm.internal_config.width = width + 'px';
        vm.internal_config.height = height + 'px';
        vm.keyChange++;
        vm.$forceUpdate();
      },

      build(config) {
        let vm = this;
        vm.internal_config = _.merge(vm.internal_config, config);
        vm.keyChange++;
        vm.$forceUpdate();
        vm.$eventHub.setValueElementConfig(vm.id, vm.internal_config);
      },

      style() {
        var style = `width: ${this.internal_config.width};
                     height:  ${this.internal_config.height};
                     z-index: ${this.internal_config.zIndex};
                     max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     left:  ${this.internal_config.left};
                     top: ${this.internal_config.top}`;
        return style;
      },

      styleResize() {
        return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
      },

      hover() {
        this.$emit('highlightHover', {name: this.name, posicao: this.$refs.image.getBoundingClientRect()});
      }
    },
    mounted() {
      this.build(this.$props.config);

      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] === this && parseInt(this.id)) {
          objIds.push(this.id)
        }
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (+this.id === +id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
    height: auto;
  }

  .resizable.vdr {
    width: 100% !important;
    height: auto !important;
    left: 0 !important;
    top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Image/Image.vue